"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const style_1 = require("./style");
const ImageViewerRenderer = ({ imageViewerContext }) => {
    const { Render, functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const onClose = () => {
        processor.root.openImageViewer({
            isOpened: false,
            urls: undefined,
        });
    };
    return (react_1.default.createElement(Render.Modal, { visible: true, animationType: "fade", transparent: true },
        react_1.default.createElement(Render.View, { style: style_1.ContainerButtonCloseStyle },
            react_1.default.createElement(Render.TouchableOpacity, { onPress: onClose },
                react_1.default.createElement(Render.SvgIcon, { name: "close", size: 25, color: "white", family: "FontAwesome" }))),
        react_1.default.createElement(Render.ImageViewer, { urls: imageViewerContext === null || imageViewerContext === void 0 ? void 0 : imageViewerContext.urls, onClose: onClose })));
};
exports.default = ImageViewerRenderer;
